import styles from './styles.module.css'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { redirectIfNoRefreshToken } from '../../shared/redirects'
import { IconMenu } from '../../widgets/icon-menu'
import { FileStoreCreationForm } from '../../widgets/file-store-creation-form'
import { RootState } from 'app/store'
import { useSelector } from 'react-redux'

export function FileStorePage () {
    const roleOperator = useSelector((state: RootState) => state.loginSlice.role)
    const navigate = useNavigate()

    if (roleOperator !== 'administrator') {
        setTimeout(() => navigate('/'))
        return <></>
    }

    useEffect(() => {
        redirectIfNoRefreshToken(navigate)
    }, [])

    return <div className={styles.PlayerPage}>
        {/* <AdminMenu /> */}
        <div className={styles.ContentContainer}>
            <div className={styles.FormContainer}>
                <IconMenu
                    onSearchClick={() => { navigate('/documents') }}
                    onDeleteClick={() => {}}
                />
                <FileStoreCreationForm />
            </div>
        </div>
    </div>
}
